/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { EmrClusterDefinitionConfiguration } from './emrClusterDefinitionConfiguration';
import { EmrClusterDefinitionEbsConfiguration } from './emrClusterDefinitionEbsConfiguration';


export interface EmrClusterDefinitionInstanceTypeConfig { 
    /**
     * An EC2 instance type, such as 'm3.xlarge'.                
     */
    instanceType?: string;
    /**
     * The priority at which Amazon EMR launches the Amazon EC2 instances with this instance type.                
     */
    priority?: string;
    /**
     * The number of units that a provisioned instance of this type provides toward fulfilling the target capacities                   defined in InstanceFleetConfig. This value is 1 for a master instance fleet, and must be greater than 0                   for core and task instance fleets                
     */
    weightedCapacity?: number;
    /**
     * The bid price for each EC2 Spot instance type as defined by InstanceType. Expressed in USD. If neither BidPrice nor                   BidPriceAsPercentageOfOnDemandPrice is provided, BidPriceAsPercentageOfOnDemandPrice defaults to 100%                
     */
    bidPrice?: string;
    /**
     * The bid price, as a percentage of On-Demand price, for each EC2 Spot instance as defined by InstanceType. Expressed as a number                   between 0 and 1000 (for example, 20 specifies 20%). If neither BidPrice nor BidPriceAsPercentageOfOnDemandPrice is provided,                   BidPriceAsPercentageOfOnDemandPrice defaults to 100%                
     */
    bidPriceAsPercentageOfOnDemandPrice?: string;
    ebsConfiguration?: EmrClusterDefinitionEbsConfiguration;
    /**
     * A configuration classification that applies when provisioning cluster instances, which can include configurations for                   applications and software that run on the cluster                
     */
    configurations?: Array<EmrClusterDefinitionConfiguration>;
}
